module.exports = __webpack_public_path__ + "img/Curso_ClaseConversacion.4371bce2.png";